import React from 'react';
import PropTypes from 'prop-types';
import FailIcon from '@learningblocks/exp-constants/lib/Images/AlertLargeFail.svg';
import {Image, Button} from '@learningblocks/storybook-components';
import style from './style.module.scss';

/**
 * GlossaryErrorState
 *  - The error state template display for glossary component.
 */
export function GlossaryErrorState(props) {
  return (
    <div className={`${style.errorMessage} ${props.className}`}>
      <Image src={props.image} alt={props.title} />
      <h3>{props.title}</h3>
      <p>{props.details}</p>
      <Button onClick={props.onRetry}>Retry</Button>
    </div>
  );
}

GlossaryErrorState.propTypes = {
  /**
   * Classname to be set for the wrapper function
   */
  className: PropTypes.string.isRequired,
  /**
   * Error icon to be displyed
   */
  image: PropTypes.string.isRequired,
  /**
   * Title for the error message
   */
  title: PropTypes.string.isRequired,
  /**
   * Detailed description for error message
   */
  details: PropTypes.string.isRequired,
  /**
   * Function to be executed when on click of retry
   */
  onRetry: PropTypes.func.isRequired,
};

GlossaryErrorState.defaultProps = {
  image: FailIcon,
  title: 'Content Not Loading',
  details: 'Please try clicking the reload button.',
  className: '',
};
